// Mock data for people to be evaluated
export interface PersonToEvaluate {
  id: string
  name: string
  position?: string
  department?: string
  state?: string
}

export const mockPeopleToEvaluate: PersonToEvaluate[] = [
  {
    id: 'person1',
    name: 'Yo',
    position: 'Autoevaluación',
    department: 'Tecnología',
    state: 'Finalizado',
  },
  {
    id: 'person2',
    name: 'Juan Pérez',
    position: 'Jefe',
    department: 'Tecnología',
    state: 'Finalizado',
  },
  {
    id: 'person3',
    name: 'María García',
    position: 'Par',
    department: 'Producto',
    state: 'En proceso',
  },
  {
    id: 'person4',
    name: 'Carlos López',
    position: 'Par',
    department: 'Diseño',
    state: 'Cerrado',
  },
  {
    id: 'person5',
    name: 'Ana Martínez',
    position: 'Cliente interno',
    department: 'Gestión',
    state: 'Sin iniciar',
  },
  {
    id: 'person6',
    name: 'Roberto Silva',
    position: 'Colaborador',
    department: 'Calidad',
    state: 'Sin iniciar',
  },
]
